export type PurchasePromoTier = {
  price: number;
  originalPrice: number;
  promoPrice: number;
  isDiscount: boolean;
  discountPercent: number;
};

export type PurchasePromo = {
  enabled: boolean;
  active: boolean;
  endsAt: string | null;
  serverNow: string | null;
  label?: string;
  tiers: Record<string, PurchasePromoTier>;
};

export const EMPTY_PURCHASE_PROMO: PurchasePromo = {
  enabled: false,
  active: false,
  endsAt: null,
  serverNow: null,
  label: 'Promo Spesial',
  tiers: {},
};

export type PromoCountdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  expired: boolean;
};

export function formatPromoEndDate(endsAt: string | null): string | null {
  if (!endsAt) return null;
  const date = new Date(endsAt);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Asia/Jakarta',
  }).format(date);
}

export function buildPromoCountdown(endsAt: string | null, active: boolean): PromoCountdown {
  if (!active || !endsAt) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  }

  const diffMs = new Date(endsAt).getTime() - Date.now();
  if (diffMs <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds, expired: false };
}
